export default {
  main: {
    hero: `
        Our games<br>
        are <strong> vibrant</strong> worlds<br>
        with <strong>charming</strong><br>
        characters
      `,
    homescapes: `An epic installment in the Scapes™ series, in which players get to restore a beautiful mansion along with Austin the Butler`,
    township: `A fun city-building game jam-packed with events, competitions, and PVP tournaments`,
    xsolla: 'Xsolla is an authorized global distributor of Playrix games',
  },
  common: {
    login: 'Login',
    logout: 'Logout',
    support: 'Support',
    privacy: 'Privacy policy',
    terms: 'Terms of service',
    and: 'and',
    guest: 'Guest',
    loading: 'Loading',
    play: 'Play',
    install: 'Install',
  },
  auth: {
    loading: '@:(common.loading)...',
  },
  support: {
    title: 'Need support?',
    description: `If you are a user of this game and you have any difficulties,
      we will be happy to help you and answer all questions`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption: `Help Austin the butler bring warmth and comfort back to his wonderful family's mansion.`,
    description: `Help Austin the butler bring warmth and comfort back
      to his wonderful family's mansion. Come on in — adventures
      await you from the moment you walk in the door!`,
    xsolla: 'Xsolla is an authorized global distributor of Homescapes',
    install: {
      title: '@:common.install',
      text: `Homescapes on your desktop!
      Install the web version of the game and visit Austin in just a couple of clicks!`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: `Build your dream town! Harvest crops, process them at your facilities, and sell goods to develop your town.`,
    description: `Build your dream town!
      Harvest crops, process them at your facilities,
      and sell goods to develop your town.`,
    xsolla: 'Xsolla is an authorized global distributor of Township',
    install: {
      title: '@:common.install',
      text: `Township on your desktop!
      Install the web version of the game and visit your town in just a couple of clicks!`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: 'This website uses cookies to ensure you get the best experience on our website',
    link: 'More info',
    button: 'Accept',
  },
  game: {
    notSupported: `Mobile devices are not supported.
      Log in from your computer to play.`,
  },
};
